module.exports = __webpack_public_path__ + "static/media/A_iko_2_EN_hover.be313223.svg";